module.exports = __webpack_public_path__ + "img/orderSelection.0a0d52be.svg";